/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import {
    object,
} from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { useUIDSeed } from 'react-uid';
import Data from './ViewData';

const styles = (theme)  => ({
    container: {
        width: '100%',
        margin: 'auto',
        marginBottom: '50px',
        maxWidth: '1440px',
        minWidth: '980px',
        padding: '0px 20px',
        '& .desc1': {
            top: '90px',
            width: '50%',
            position: 'absolute',
            left: '450px',
            '& span': {
                display: 'block',
                marginTop: '12px',
                fontWeight: 'bold',
            },
        },
        '& .desc2': {
            position: 'absolute',
            width: '70%',
            left: '250px',
            top: '90px',
            '& span': {
                display: 'block',
                marginTop: '12px',
                fontWeight: 'bold',
            },
        },
        '& .desc3 , .desc4': {
            width: '50%',
            top: '70px',
            position: 'absolute',
            left: '425px',
            '& span': {
                display: 'block',
                marginTop: '12px',
                fontWeight: 'bold',
            },
        },
        '& .desc5': {
            top: '80px',
            left: '475px',
            width: '45%',
            position: 'absolute',
            '& span': {
                display: 'block',
                marginTop: '12px',
                fontWeight: 'bold',
            },
        },
        '& .desc6': {
            position: 'absolute',
            width: '65%',
            top: '120px',
            '& span': {
                display: 'block',
                marginTop: '12px',
                fontWeight: 'bold',
            },
        },
        '& .desc7': {
            position: 'absolute',
            width: '62%',
            top: '65px',
            '& span': {
                display: 'block',
                marginTop: '12px',
                fontWeight: 'bold',
            },
        },
    },
    title: {
        color: theme.palette.common.black,
        fontSize: '34px',
        fontWeight: 'lighter',
        margin: '5px 0px',
    },
    content: {
        border: '1px solid',
        margin: '10px 0px',
        position: 'relative',
        fontSize: '13px',
        textAlign: 'center',
        lineHeight: '24px',
    },
});

const  SympathyCustomerTestimonialsPage = ({ classes }) => {
    const { title, list } = Data;
    const seed = useUIDSeed();
    return (
        <div className={classes.container}>
            <Grid container>
                <Grid item xs={12}>
                    <h1 className={classes.title}>{title}</h1>
                </Grid>
                {
                    list.map((data) => {
                        const {
                            description, image, alt_text,
                        } = data;
                        return (
                            <Grid key={seed(data)} container className={classes.content}>
                                <Grid item xs={3}>
                                    <img src={image} alt={alt_text} />
                                </Grid>
                                <Grid item xs={9}>
                                    {ReactHtmlParser(description)}
                                </Grid>
                            </Grid>
                        );
                    })
                }
            </Grid>
        </div>
    );
};

SympathyCustomerTestimonialsPage.propTypes = {
    classes: object.isRequired,
};
export default withStyles(styles)(SympathyCustomerTestimonialsPage);
